import { PsResourceCompany } from '../../shared/model/resource/PsResourceCompany';
import { PsResourceDocumentation } from '../../shared/model/resource/PsResourceDocumentation';
import WorkerContractorState from '../../shared/model/WorkerContractorState';
import WorkerState from '../../shared/model/WorkerState';

export class PsWorker {

    _id; // number
    _dni; // string
    _job; // string
    _name; // string
    _active; // boolean
    _company; // PsResourceCompany
    _lastName; // string
    _agreement; // string
    _documentation; // PsResourceDocumentation

    constructor(
        id,
        dni,
        job,
        name,
        active,
        company,
        lastName,
        agreement,
        documentation,
    ) {
        this._id = id;
        this._dni = dni;
        this._job = job;
        this._name = name;
        this._active = active;
        this._company = company;
        this._lastName = lastName;
        this._agreement = agreement;
        this._documentation = documentation;
    }

    static fromAPIWorkers(workers, currentUser) {
        return workers.map((worker) => PsWorker.fromAPIWorker(worker, currentUser));
    }

    static fromAPIWorker(worker, currentUser) {
        const { worker_documentation_state: state } = worker;
        let active;
        if ( worker.worker_contractor_state ) {
            active = worker.worker_contractor_state.id === WorkerState.ACTIVE;
        } else {
            active = worker.worker_state.id === WorkerState.ACTIVE;
        }

        return new this(
            worker.id,
            worker.dni,
            worker.position || '',
            worker.name || '',
            active,
            worker.company ? PsResourceCompany.fromAPICompany(worker.company) : PsResourceCompany.null(),
            worker.last_name || '',
            worker.agreement || '',
            PsResourceDocumentation.fromAPIOutsourceResource(currentUser, worker, state),
        );
    }

    id() {
        return this._id;
    }

    dni() {
        return this._dni;
    }

    job() {
        return this._job;
    }

    name() {
        return this._name;
    }

    lastName() {
        return this._lastName;
    }

    completeName() {
        return `${this.name()} ${this.lastName()}`;
    }

    agreement() {
        return this._agreement;
    }

    isActive() {
        return this._active;
    }

    company() {
        return this._company;
    }

    companyId() {
        return this.company().id();
    }

    companyDescription() {
        return this.company().description();
    }

    documentation() {
        return this._documentation;
    }

    documentationDescription() {
        return this.documentation().mySchemaDescription();
    }

    documentationStateData() {
        return this.documentation().stateData();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/PsWorker.js